import PropTypes from 'prop-types';
import { formatDate, formatAmount } from 'Shared/util/formatters';
import DataTable, { ColumnTypes } from 'Shared/components/tables/data-table';
import { useTranslation } from 'Shared/util/custom-hooks';
import { translateColumns, funcFilterProperties } from 'Shared/util/translations';


const columns = [
  {
    title: 'invoiceNumber',
    key: 'number',
  },
  {
    title: 'customer',
    key: 'debtor',
  },
  {
    title: 'invoiceDate',
    key: 'invoiceDate',
    type: ColumnTypes.Date,
    formatter: (d) => formatDate(d),
  },
  {
    title: 'dueDate',
    key: 'dueDate',
    type: ColumnTypes.Date,
    formatter: (d) => formatDate(d),
    hiddenMobile: true,
  },
  {
    title: 'totalAmount',
    key: 'totalAmount',
    type: ColumnTypes.Amount,
    formatter: (d) => formatAmount(d),
    footer: {
      sum: true,
    },
  },
  {
    title: 'remainingAmount',
    key: 'remainingAmount',
    type: ColumnTypes.Amount,
    formatter: (d) => formatAmount(d),
    footer: {
      sum: true,
    },
    hiddenMobile: true,
  },
  {
    title: 'currency',
    key: 'currencyCode',
    footer: {
      groupBy: true,
    },
  },
  {
    title: 'status',
    key: 'status',
  },
];

const getRowLink = (row) => `/invoices/${row.id}`;

const BasicInvoiceTable = ({
  columns: customColumns,
  rows,
  loading,
  filterProperties,
}) => {
  const tg = useTranslation(x => x.global);
  const ti = useTranslation(x => x.invoiceStatus);
  const ti2 = useTranslation(x => x.invoiceStatus2MapOnId);

  return (
    <DataTable
      loading={loading}
      columns={customColumns || translateColumns(columns, tg)}
      rows={funcFilterProperties(rows, { ...ti, ...ti2 }, filterProperties, ['status'])}
      getRowLink={getRowLink}
    />
  );
};

BasicInvoiceTable.defaultProps = {
  filterProperties: ['status'],
};

BasicInvoiceTable.propTypes = {
  columns: PropTypes.array,
  rows: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  filterProperties: PropTypes.array,
};

export default BasicInvoiceTable;
